import { render, staticRenderFns } from "./GiftCardEditor.vue?vue&type=template&id=12008551&scoped=true&"
import script from "./GiftCardEditor.vue?vue&type=script&lang=js&"
export * from "./GiftCardEditor.vue?vue&type=script&lang=js&"
import style0 from "./GiftCardEditor.vue?vue&type=style&index=0&id=12008551&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "12008551",
  null
  
)

export default component.exports